// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Kn-z","tupacHeader":"Ln-z","tupacHeader2":"Mn-z","tupacMenu":"Nn-z","tupacMenu2":"On-z","tupacMain":"Pn-z","tupacMain2":"Qn-z"};